import { useMemo } from 'react';
import { Content, useContent } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { InventoryMetrics } from 'src/tiles/ListingTilesV2';
import { ContentId } from 'src/utils/constants/contentId';
import { getQuantityNumberFormat } from 'src/utils/format';
import { EventWithData, Venue } from 'src/WebApiController';

import { InventoryEventTabs } from '../../../InventoryEventTabs';
import { useInventoryEventLocalContext } from '../../InventoryEventLocalContext';
import * as styles from './InventoryEventHeaderMobile.css';

export const EventHeaderWithNavMobile = ({
  inventoryMetrics,
  event,
  venue,
}: {
  inventoryMetrics: InventoryMetrics;
  event?: EventWithData;
  venue?: Venue;
}) => {
  const { activeTab } = useInventoryEventLocalContext();
  const listingsText = useContent(ContentId.Listings);
  const ticketsText = useContent(ContentId.Tickets);

  const metricsText = useMemo(() => {
    const listingsCount = `${getQuantityNumberFormat().format(inventoryMetrics.listingCount)} ${listingsText}`;
    const ticketsCount = `${getQuantityNumberFormat().format(inventoryMetrics.ticketCount)} ${ticketsText}`;
    return [listingsCount, ticketsCount].join(', ');
  }, [
    inventoryMetrics.listingCount,
    inventoryMetrics.ticketCount,
    listingsText,
    ticketsText,
  ]);

  const isShowingInventory = useMemo(
    () =>
      activeTab === InventoryEventTabs.Info ||
      activeTab === InventoryEventTabs.ManualPricing,
    [activeTab]
  );

  if (!event || !isShowingInventory) return null;

  return (
    <Stack
      width="full"
      alignItems="center"
      justifyContent="spaceBetween"
      style={{
        backgroundColor: vars.color.backgroundPrimary,
        padding: `${vars.spacing.m} 0`,
      }}
    >
      <span style={{ textTransform: 'capitalize' }}>{metricsText}</span>
      {inventoryMetrics.allAvailableTickets && (
        <span className={styles.metricsSubtitle}>
          {getQuantityNumberFormat().format(
            inventoryMetrics.allAvailableTickets
          )}{' '}
          <Content id={ContentId.Available} />
        </span>
      )}
    </Stack>
  );
};
